import React, { useState } from "react";
import "./DS.css";
import Header from "../../../component/header";
import SideNav from "../../../component/sideNav";
import Loader from "../MainComponent/loader";
import DSDetail from "./DSDetails";

export default function DS() {
  const [loader, setLoader] = useState(false);

  return (
    <>
      {loader && <Loader backgroundColor={"#000000db"}></Loader>}
      <div className="dsContainer">
        <Header></Header>
        <SideNav active="Dashboard" />
        <div className="dsContent">
          <DSDetail setLoader={setLoader} loader={loader}></DSDetail>
        </div>
      </div>
    </>
  );
}
